import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const PcoTabNames = Object.freeze({
  // we need to explicitly cast values to get the proper literal type
  CreateMemberCode: 'CREATE_MEMBER_CODE' as const,
  OverviewMemberCode: 'OVERVIEW_MEMBER_CODE' as const,
  NewMandate: 'NEW_MANDATE' as const,
  Case: 'CASE' as const,
  VideoIdentificationForm: 'VIDEO_IDENTIFICATION_FORM' as const,
  VideoIdentification: 'VIDEO_IDENTIFICATION' as const,
  SubscriptionManagement: 'SUBSCRIPTION_MANAGEMENT' as const,
  AddProductOrService: 'ADD_PRODUCT_OR_SERVICE' as const,
  ProductConfiguration: 'PRODUCT_CONFIGURATION' as const,
  ProductDetails: 'PRODUCT_DETAILS' as const,
  OrderNewProductOrService: 'ORDER_NEW_PRODUCT_OR_SERVICE' as const,
});

const shownPageSlice = createSlice({
  name: 'SHOWN_PAGE',
  initialState: '',
  reducers: {
    setShownPage: (state, action: PayloadAction<string>) => {
      return action.payload;
    },
  },
});

export const { setShownPage } = shownPageSlice.actions;
export default shownPageSlice.reducer;
